import classNames from "classnames";
import React from "react";
import { actions, Control } from "react-redux-form";
import { Dispatch } from "redux";
import _ from "underscore";

import { Errors } from "../../../../core/atoms/rrf";
import { CommonProps, EnquiryFormSection } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

import "./phoneNumber.scss";

interface OwnProps {
  dispatch: Dispatch<IWebStoreState>;
}

export class PhoneNumber extends EnquiryFormSection<OwnProps> {
  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return !_.isEqual(oldProps.formState.account.phoneNumber, newProps.formState.account.phoneNumber);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    this.props.dispatch(actions.setErrors(this.props.model, { required: !formState.account.phoneNumber || formState.account.phoneNumber.length < 1 }));
  }

  public render() {
    const { model, className, id, formState, user } = this.props;
    const locationName = formState.location ? formState.location.name : "?";
    const hasPhoneNumber = user && user.phoneNumber && user.phoneNumber.length > 1; // formState.account.phoneNumber changes when input.

    return (
      <section id={id} className={classNames("phone-number-field", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>What's your phone number?</h2>
          <p>To enquire to {locationName}, we need to take a phone number - it may be useful for us to discuss your plans.</p>
        </header>

        <div className="enquiry-form-question">
          <Errors model={model} messages={{ required: "We need your phone number to continue" }} />

          {hasPhoneNumber &&
            <div><p><em>You've enquired with us before - please check if the phone number we have for you is still correct.</em></p></div>
          }

          <label className="tel-input-wrap">
            <p><strong>Your phone number (include international dialling code)</strong></p>
            <Control.text model={model} type="tel" autoComplete="tel" placeholder="e.g. +44 (0)117 325 7898" />
          </label>
        </div>
      </section>
    );
  }
}
